import React from 'react';

import { TFunction } from '@lyearn/i18n';
import { CheckMarkCircle2 } from '@lyearn/icons';
import { Box, Stack, Typography } from '@lyearn/ui';
import * as BaseCard from '@/modules/content/components/ContentCard/BaseCard';

export const renderProgressStatus = (t: TFunction, progress = 0, isDiscoverPage?: boolean) => {
  const isCompleted = progress === 100;

  if (isCompleted) {
    return (
      <Stack alignItems="center" className={isDiscoverPage ? 'mb-16 mt-auto' : 'mt-auto'} gapX={6}>
        <Stack alignItems="center" className="my-8" direction="row">
          <CheckMarkCircle2 className="h-16 w-16" fillColorToken="icon-success" />
          <Typography className="ms-4" color="text-text-success" variant="label-02">
            {t('ContentCards.Completed')}
          </Typography>
        </Stack>
      </Stack>
    );
  }

  return (
    <Box className={isDiscoverPage ? 'mb-24 mt-auto' : 'mt-auto'}>
      <BaseCard.Progress className="my-8" />
    </Box>
  );
};
